module.exports = __webpack_public_path__ + "img/CLS-P-590.3abf11e3.svg";